export default {
  'EditActVideos.delete': { en: 'Remove', fr: 'Éliminer' },
  'EditActVideos.addYoutube': {
    en: 'Add a YouTube video',
    fr: 'Ajouter une vidéo YouTube',
  },
  'EditActVideos.addVideo': { en: 'Add Video', fr: 'Ajouter une vidéo' },
};
